<div class="latest-blog-loop bg-white">
  <mat-horizontal-stepper [linear]="isLinear" #stepper style="background: #fefefe !important">
    <form [formGroup]="formCotacao">
      <!-- passo 1 -->
      <mat-step>
        <ng-container>
          <div class="row justify-content-center">
            <!-- Formulário Centralizado -->
            <div class="col-md-8 justify-content-center col-sm-12 campo-formulario">
              <div class="text-section margin-text order-md-2 mobile">
                <div class="progress-overlay d-flex justify-content-center align-items-center" style="margin-top: 60px">
                  <div class="text-center-iris mb-1" style="width: 100%">
                    <div class="d-flex align-items-center justify-content-center">
                      <div class="caixa-texto-iris">
                        <p class="subtitle">
                          <span class="subt-title-left">Etapa 1 de 2</span>
                        </p>
                      </div>
                    </div>
                    <div
                      class="progress-bar-container"
                      style="
                        width: 100%;

                        position: relative;
                        height: 30px;
                      ">
                      <div
                        (ngModelChange)="barraDeProgressoPasso1()"
                        class="progress-bar"
                        [style.width]="buttonEnabled ? '70%' : '0%'"
                        style="
                          background-color: #407590;
                          height: 100%;
                          transition: width 0.5s;
                          position: relative;
                        "></div>
                      <div
                        class="progress-text"
                        [style.color]="buttonEnabled ? 'white' : 'black'"
                        style="
                          position: absolute;
                          width: 100%;
                          text-align: center;
                          top: 0;
                          left: 0;
                          height: 100%;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        ">
                        {{ buttonEnabled ? '70% Preenchido' : '' }}
                      </div>
                    </div>
                  </div>
                </div>
                <h3 class="subtitle col-sm-12">
                  <span class="subt-title-left" style="font-weight: 400 !important; color: #407590 !important">
                    <b>Bem-vindo!</b>
                    Precisamos de algumas informações para apresentar os melhores e mais baratos
                    <b>planos de saúde para o seu perfil.</b>
                  </span>
                </h3>
                <div class="row wizard-content mt-1">
                  <div class="col-12">
                    <div class="form-group row">
                      <!-- Profissão -->
                      <div class="form-group col-md-12 mb-1 col-sm-12">
                        <ng-select
                          class="input-name round bg-white shadow"
                          [closeOnSelect]="true"
                          [multiple]="false"
                          (ngModelChange)="barraDeProgressoPasso1()"
                          [searchable]="true"
                          [loading]="false"
                          notFoundText="Nenhum registro localizado"
                          formControlName="idProfissao"
                          placeholder="Profissão"
                          required>
                          <ng-option *ngFor="let option of listaProfissoes" [value]="option.id">
                            {{ option.name }}
                          </ng-option>
                        </ng-select>
                      </div>
                      <!-- Estado -->
                      <div class="col-md-6 mb-1 col-sm-12">
                        <ng-select
                          class="input-name round bg-white shadow"
                          [closeOnSelect]="true"
                          [multiple]="false"
                          [searchable]="true"
                          [loading]="false"
                          placeholder="Estado"
                          notFoundText="Nenhum registro localizado"
                          (ngModelChange)="barraDeProgressoPasso1()"
                          formControlName="idEstado"
                          required>
                          <ng-option *ngFor="let option of listaEstados" [value]="option.id">
                            {{ option.uf }} -
                            {{ option.name }}
                          </ng-option>
                        </ng-select>
                      </div>
                      <!-- Cidade -->
                      <div class="col-md-6 mb-1 col-sm-12">
                        <ng-select
                          class="input-name round bg-white shadow"
                          [closeOnSelect]="true"
                          [multiple]="false"
                          (ngModelChange)="barraDeProgressoPasso1()"
                          [searchable]="true"
                          [loading]="false"
                          placeholder="Cidade"
                          notFoundText="Nenhum registro localizado"
                          formControlName="idCidade"
                          required>
                          <ng-option *ngFor="let option of listaCidadePorEstado" [value]="option.id">
                            {{ option.name }}
                          </ng-option>
                        </ng-select>
                      </div>
                      <!-- Idade -->
                      <div class="col-md-4 mb-1 col-sm-12">
                        <input
                          style="background-color: white !important"
                          required
                          bsDatepicker
                          name="dataNascimentoTitular"
                          type="text"
                          (ngModelChange)="barraDeProgressoPasso1()"
                          class="form-control round"
                          placeholder="Data de Nascimento"
                          [bsConfig]="bsConfig"
                          formControlName="age" />
                      </div>
                      <!-- Idade do dependente -->
                      <div class="col-md-3 mb-1 col-sm-12">
                        <button
                          type="button"
                          style="background-color: #407590 !important"
                          class="btn btn-round bg-side-bar-geia white box-shadow-4"
                          (click)="adicionarDependente()"
                          [disabled]="dependentes.length >= 6">
                          <i class="ft-plus white"></i>
                          Adicionar Dependente
                        </button>
                      </div>
                      <!-- <pre>Dependentes{{_cotacaoVM.dependentes | json}}</pre> -->
                      <div formArrayName="aniversariosDependentes" class="col-md-12">
                        <div class="row mb-1">
                          <ng-container
                            *ngFor="let dependente of dependentes.controls; let i = index"
                            [formGroupName]="i">
                            <!-- Campo de Idade do dependente -->
                            <div class="col-md-5 col-sm-12 mb-1">
                              <input
                                style="background-color: white !important"
                                required
                                bsDatepicker
                                id="{{ i }}"
                                name="dataNascimentoDependente"
                                type="text"
                                class="form-control round"
                                [placeholder]="'Data de Nascimento dependente ' + (i + 1)"
                                [bsConfig]="{
                                  isAnimated: true,
                                  adaptivePosition: true
                                }"
                                formControlName="dataNascimentoDependente" />
                            </div>
                            <!-- Botão de remover -->
                            <div class="col-md-1 col-sm-12 mb-1">
                              <button type="button" (click)="removerDependente(i)" class="btn btn-danger round">
                                <i class="fa fa-times white"></i>
                              </button>
                            </div>
                            <!-- Quebra de linha automática para a próxima linha após dois inputs -->
                            <div *ngIf="(i + 1) % 2 === 0" class="w-100"></div>
                          </ng-container>
                        </div>
                      </div>
                      <div class="row text-center subt-title-left" style="background: #fff; border-radius: 5px">
                        <div class="col-12 col-md-12 col-sm-12 mb-1">
                          <label class="termo-aceite" for="checkbox">
                            Antes de prosseguir, você precisa aceitar nossos Termos de Uso.
                          </label>
                          <input
                            [value]="isVisible"
                            (change)="isConcorda($event)"
                            id="checkbox"
                            type="checkbox"
                            (ngModelChange)="barraDeProgressoPasso1()" />
                          <label class="termo-aceite" for="checkbox">
                            Eu Concordo com os
                            <a class="ml-1" target="_blank" [routerLink]="['/politica-de-privacidade']">
                              Termos e Condições,
                            </a>
                            incluindo nosso uso de cookies.
                          </label>
                        </div>
                      </div>
                      <!-- Buttons -->
                      <div class="button-mobile d-flex justify-content-between w-100 mt-2">
                        <button (click)="voltar()" class="btn-simule btn btn-outline-secondary" style="height: 40px">
                          <i class="fa fa-arrow-left"></i>
                          Voltar
                        </button>

                        <!-- <button mat-button (click)="goToNextStep(stepper)">
                              Next
                            </button> -->
                        <button
                          (click)="validarCampos(stepper)"
                          [disabled]="
                            this.isVisible == false ||
                            formCotacao.controls['idProfissao'].invalid ||
                            formCotacao.controls['idProfissao'].errors ||
                            formCotacao.controls['idEstado'].invalid ||
                            formCotacao.controls['idEstado'].errors ||
                            formCotacao.controls['idCidade'].invalid ||
                            formCotacao.controls['idCidade'].errors ||
                            formCotacao.controls['age'].invalid ||
                            formCotacao.controls['age'].errors
                          "
                          class="btn-simule btn btn-outline-secondary"
                          style="height: 40px">
                          <i class="fa fa-arrow-right"></i>
                          Avançar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </mat-step>
      <!--OUTRA PROFISSAO -->
      <mat-step *ngIf="heOutraProfissao">
        <ng-container>
          <div class="row wizard-content">
            <div class="col-md-6 d-flex flex-column justify-content-center align-items-center">
              <div class="form-group ml-5">
                <div class="col-lg-10 mb-2">
                  <div class="section-heading heading-white">
                    <span
                      class="subt-title-left span-20px"
                      style="font: normal normal normal 26px / 26px Montserrat; color: #fff">
                      Temos a oferta ideal para você!
                    </span>
                    <h2 class="title-left font-title-blog-h2" style="line-height: 1.4; font-size: 18px !important">
                      Fale com um de nossos atendentes, ou aguarde nosso contato.
                    </h2>
                  </div>
                </div>
              </div>
              <div class="button-mobile d-flex justify-content-between w-75 mt-1">
                <!-- <button matStepperPrevious class="btn-simule btn btn-outline-secondary">
                      <i class="fa fa-arrow-left fa-2x"></i>
                    </button> -->

                <button matStepperPrevious class="btn-simule btn btn-outline-secondary" style="height: 40px">
                  <i class="fa fa-arrow-left"></i>
                  Voltar
                </button>

                <a href="https://api.whatsapp.com/send?phone=551136602000" target="_blank" class="d-flex">
                  <button class="cursor-pointer round text-white mr-4" style="background-color: #49c858">
                    <i class="fa fa-whatsapp btn text-white"></i>
                    <span style="letter-spacing: 2px !important" class="mr-2 bold">(11) 3660-2000</span>
                  </button>
                </a>
              </div>
            </div>
            <div class="col-md-6 d-flex justify-content-center align-items-center position-relative">
              <div class="mobile-mockup-container">
                <div class="mobile-mockup">
                  <img src="../../../../../../assets/app-assets/images/site/familia-whats.png" alt="Familia" />
                </div>
                <div class="mobile-outline"></div>
                <div class="mobile-outline-button-cell"></div>
              </div>
            </div>
          </div>
        </ng-container>
      </mat-step>
      <!-- OUTRA PROFISSAO -->
      <!-- passo 2 -->
      <mat-step>
        <ng-container>
          <div class="row justify-content-center">
            <!-- Formulário Centralizado -->
            <div class="col-md-8 col-sm-12 campo-formulario">
              <div class="text-section margin-text order-md-2 mobile">
                <div class="progress-overlay d-flex justify-content-center align-items-center" style="margin-top: 60px">
                  <div class="text-center-iris mb-1" style="width: 100%">
                    <div class="d-flex align-items-center justify-content-center">
                      <div class="caixa-texto-iris">
                        <p class="subtitle">
                          <span class="subt-title-left">Etapa 2 de 2</span>
                        </p>
                      </div>
                    </div>
                    <div
                      class="progress-bar-container"
                      style="width: 100%; border: 1px solid #ccc; position: relative; height: 30px">
                      <!-- Barra de progresso -->
                      <div
                        class="progress-bar"
                        [ngClass]="{
                          'no-border-radius': barraDeProgressoPasso2()
                        }"
                        [style.width]="barraDeProgressoPasso2() ? '100%' : '70%'"
                        style="
                          background-color: #407590;
                          height: 100%;
                          transition: width 0.5s;
                          position: relative;
                        "></div>
                      <!-- Texto da barra de progresso -->
                      <div
                        class="progress-text"
                        style="
                          color: white;
                          position: absolute;
                          width: 100%;
                          text-align: center;
                          top: 0;
                          left: 0;
                          height: 100%;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        ">
                        {{
                          barraDeProgressoPasso2()
                            ? '100% Preenchido'
                            : '70%
                            Preenchido'
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <h3 class="subtitle">
                  <span class="subt-title-left" style="font-weight: 400 !important; color: #407590 !important">
                    <b>Fique Tranquilo,</b>
                    seus dados
                    <b>estão seguros</b>
                    conosco.
                    <b>Não compartilhamos</b>
                    suas informações com terceiros e não usaremos para
                    <b>envio de SPAN.</b>
                  </span>
                </h3>
                <div class="row wizard-content mt-1">
                  <div class="col-12">
                    <div class="form-group row">
                      <!-- Nome -->
                      <div class="col-md-12 mb-1 col-sm-12">
                        <input
                          matInput
                          class="input-name round form-control"
                          formControlName="nome"
                          required
                          (ngModelChange)="barraDeProgressoPasso2()"
                          placeholder="Nome e Sobrenome" />
                        <div
                          class="text-danger"
                          *ngIf="
                            formCotacao.get('nome')?.invalid &&
                            (formCotacao.get('nome')?.touched || formCotacao.get('nome')?.dirty)
                          ">
                          <div class="text-danger" *ngIf="formCotacao.get('nome')?.hasError('checkName')">
                            {{ formCotacao.get('nome')?.errors?.['checkName'] }}
                          </div>
                        </div>
                      </div>
                      <!-- email -->
                      <div class="col-md-12 mb-1 col-sm-12">
                        <input
                          type="email"
                          class="input-name round form-control"
                          (ngModelChange)="barraDeProgressoPasso2()"
                          formControlName="email"
                          required
                          placeholder="email" />
                        <div
                          class="errors"
                          *ngIf="
                            formCotacao.get('email')?.invalid &&
                            (formCotacao.get('email')?.touched || formCotacao.get('email')?.dirty)
                          ">
                          <div class="errors" *ngIf="formCotacao.get('email')?.hasError('checkEmail')">
                            {{ formCotacao.get('email')?.errors?.['checkEmail'] }}
                          </div>
                        </div>
                      </div>
                      <!-- Celular -->
                      <div class="col-md-4 mb-1 col-sm-12">
                        <input
                          placeholder="Celular"
                          matInput
                          (ngModelChange)="barraDeProgressoPasso2()"
                          class="input-name round form-control form-control"
                          mask="(00) 00000-0000"
                          matInput
                          formControlName="contato"
                          required />
                      </div>
                      <div class="container">
                        <app-captcha #captcha (tokenChange)="captchaToken = $event"></app-captcha>
                      </div>

                      <!-- Buttons ||  -->
                      <div class="button-mobile d-flex justify-content-between w-100 mt-2">
                        <button matStepperPrevious class="btn-simule btn btn-outline-secondary" style="height: 40px">
                          <i class="fa fa-arrow-left"></i>
                          Voltar
                        </button>
                        <!-- <button mat-button (click)="goToNextStep(stepper)">
                              Next
                            </button> -->

                        <button
                          (click)="validarCampos(stepper)"
                          [disabled]="
                            formCotacao.controls['nome'].invalid ||
                            formCotacao.controls['nome'].errors ||
                            formCotacao.controls['contato'].invalid ||
                            formCotacao.controls['contato'].errors ||
                            !captchaToken
                          "
                          class="btn-simule btn btn-outline-secondary cursor-pointer btn-min-width">
                          <i class="fa fa-check"></i>
                          Finalizar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </mat-step>
      <!-- RESULTADO START -->
      <mat-step>
        <ng-container>
          <div class="justify-content-center container-produtos centralizar-pagina-produtos">
            <!-- Formulário Centralizado -->
            <div class="col-md-12 col-sm-12 mobile-layout">
              <div class="content-body mt-3">
                <div class="col-xl-12 col-lg-12">
                  <div class="conteudo-tab" style="margin-bottom: -24px; margin-top: -44px">
                    <div class="card-content">
                      <div class="card-body tabbable">
                        <div class="card-block text-center">
                          <div *ngIf="heOdonto" class="row">
                            <h1
                              style="font-size: 2rem !important"
                              class="title espacamento-texto-parte-um-black-friday-2024">
                              Encontramos
                              <span
                                style="
                                  font-size: 2rem !important;
                                  font-weight: 300 !important;
                                  text-transform: lowercase;
                                "
                                class="title-banner title preto-geia">
                                (3) operadoras disponíveis
                              </span>
                              para o seu perfil.
                            </h1>

                            <p
                              class="subtitle text-center mobile-paragrafo"
                              style="margin-top: 20px !important; margin-bottom: 20px !important">
                              Clique e escolha a
                              <span class="preto-geia"><b>opção que melhor atende</b></span>
                              às suas necessidades.
                              <br />
                            </p>
                            <hr />
                          </div>
                        </div>

                        <ul
                          *ngIf="heOdonto"
                          class="nav nav-tabs nav-linetriangle col-md-12 tab-odonto-center"
                          id="sectionAbas">
                          <li [style.flex]="true ? '1' : 'unset'" class="nav-item cursor-pointer">
                            <a
                              (click)="onChangeCotacaoResultado(_tipoProduto_E_OperadoraEnum.UNIMED_ODONTO)"
                              class="titulo-tab nav-link active show cursor-pointer"
                              id="unimedOdonto"
                              data-toggle="tab"
                              aria-controls="tabUmimedOdonto"
                              href="#tabUmimedOdonto"
                              aria-expanded="true">
                              <i class="fa fa-check-circle"></i>
                              UNIMED ODONTO
                            </a>
                          </li>
                          <li class="nav-item cursor-pointer">
                            <a
                              (click)="onChangeCotacaoResultado(_tipoProduto_E_OperadoraEnum.UNIODONTO)"
                              tooltipClass="tooltip"
                              class="titulo-tab nav-link cursor-pointer"
                              id="uniOdonto"
                              data-toggle="tab"
                              aria-controls="tabUniOdonto"
                              href="#tabUniOdonto"
                              aria-expanded="false">
                              <i class="fa fa-check-circle"></i>
                              UNIODONTO
                            </a>
                          </li>
                          <li class="nav-item cursor-pointer">
                            <a
                              (click)="onChangeCotacaoResultado(_tipoProduto_E_OperadoraEnum.ODONTOPREV)"
                              tooltipClass="tooltip"
                              class="titulo-tab nav-link"
                              id="odontoPrev"
                              data-toggle="tab"
                              aria-controls="tabOdontoPrev"
                              href="#tabOdontoPrev"
                              aria-expanded="false">
                              <i class="fa fa-check-circle"></i>
                              ODONTOPREV
                            </a>
                          </li>
                        </ul>

                        <div class="tab-content px-1 pt-1" [ngStyle]="heOdonto ? {'margin-top': '-34px'} : {}">
                          <!-- card Modal START -->
                          <section
                            class="container-1600 justify-content-center mt-1 row"
                            style="
                              background-color: #fefefe 0% 0% no-repeat padding-box;
                              margin-bottom: -15px;
                              transform: scale(0.9);
                            ">
                            <div class="scroll-horizontal-card-elegibilidades">
                              <div
                                class="scroll bg-light d-flex justify-content-center align-items-center"
                                style="
                                  background: #fefefe !important;
                                  padding: 20px 0px 12px 20px;
                                  overflow-y: hidden !important;
                                ">
                                <div
                                  data-toggle="modal"
                                  *ngIf="
                                    (heOdonto && this.tipoOperadoraSelecionada == 6) ||
                                    this.tipoOperadoraSelecionada == 5
                                  "
                                  data-target="#modal-cobertura"
                                  class="cursor-pointer card-top card-top round">
                                  <div class="card-body">
                                    <h5 class="blog-title mt-2">
                                      <span class="desc-card-doctor bold-azul-geia f-600">Cobertura</span>
                                    </h5>
                                  </div>
                                </div>
                                <div
                                  data-toggle="modal"
                                  *ngIf="!heOdonto"
                                  data-target="#modal-cobertura"
                                  class="cursor-pointer card-top card-top round">
                                  <div class="card-body">
                                    <h5 class="blog-title mt-2">
                                      <span class="desc-card-doctor bold-azul-geia f-600">Cobertura</span>
                                    </h5>
                                  </div>
                                </div>
                                <div
                                  data-toggle="modal"
                                  *ngIf="
                                    (heOdonto && this.tipoOperadoraSelecionada == 6) ||
                                    this.tipoOperadoraSelecionada == 5
                                  "
                                  data-target="#modal-elegiveis"
                                  class="card-top round cursor-pointer">
                                  <div class="card-body">
                                    <h5 class="blog-title mt-2">
                                      <span class="desc-card-doctor bold-azul-geia f-600">Elegíveis</span>
                                    </h5>
                                  </div>
                                </div>
                                <div
                                  data-toggle="modal"
                                  *ngIf="!heOdonto"
                                  data-target="#modal-elegiveis"
                                  class="card-top round cursor-pointer">
                                  <div class="card-body">
                                    <h5 class="blog-title mt-2">
                                      <span class="desc-card-doctor bold-azul-geia f-600">Elegíveis</span>
                                    </h5>
                                  </div>
                                </div>
                                <div
                                  data-toggle="modal"
                                  data-target="#modal-pronto-atendimento"
                                  class="card-top round cursor-pointer">
                                  <div class="card-body">
                                    <h5 class="blog-title" style="text-align: left">
                                      <span
                                        style="margin-top: -8px"
                                        *ngIf="!heOdonto"
                                        class="desc-card-doctor bold-azul-geia f-600">
                                        Pronto
                                        <br />
                                        atendimento
                                        <br />
                                        On-line
                                      </span>
                                    </h5>
                                    <h5 *ngIf="heOdonto" class="blog-title mt-2">
                                      <span class="desc-card-doctor bold-azul-geia f-600">Descrição</span>
                                    </h5>
                                  </div>
                                </div>
                                <div
                                  *ngIf="!heOdonto"
                                  data-toggle="modal"
                                  data-target="#modal-duvidas"
                                  class="card-top round cursor-pointer">
                                  <div class="card-body">
                                    <h5 class="blog-title">
                                      <span class="desc-card-doctor bold-azul-geia f-600">
                                        Dúvidas
                                        <br />
                                        Frequentes
                                      </span>
                                    </h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                          <hr />
                          <!-- card end -->
                          <!-- resultado SAUDE start -->

                          <section class="justify-content-center" *ngIf="!heOdonto">
                            <div class="carousel-container">
                              <!-- Botão anterior -->
                              <button
                                *ngIf="listasDeProdutos[tipoOperadoraSelecionada].length > 2"
                                class="carousel-control-prev"
                                (click)="scrollPrev()"
                                aria-label="Previous">
                                <i class="fa fa-chevron-left fa-1x"></i>
                              </button>

                              <!-- Cards com scroll horizontal -->
                              <div class="carousel-content cards-wrapper">
                                <app-card-resultado-cotacao
                                  *ngFor="let item of listaProdutosDM && listasDeProdutos[tipoOperadoraSelecionada]"
                                  [abrangencia]="item.abrangencia"
                                  [descricao]="item.descricao"
                                  [numeroRegistro]="item.numeroRegistro"
                                  [valor]="item.valor"
                                  [id]="item.id"
                                  [idPessoa]="item.idPessoa"
                                  [idProfissao]="item.idProfissao"
                                  [acomodacao]="item.acomodacao"
                                  [ehSaude]="true"
                                  (comprar)="
                                    comprarOnLine(
                                      item.idLead,
                                      item.contractProductCompanyId,
                                      item.branchCompanyContractId
                                    )
                                  "></app-card-resultado-cotacao>
                              </div>

                              <!-- Botão próximo -->
                              <button
                                *ngIf="listasDeProdutos[tipoOperadoraSelecionada].length > 2"
                                class="carousel-control-next carousel-control-next-saude"
                                (click)="scrollNext()"
                                aria-label="Next">
                                <i class="fa fa-chevron-right fa-1x"></i>
                              </button>
                            </div>
                          </section>

                          <!-- Usando o componente PlanoCard no HTML principal -->
                          <ng-container *ngIf="heOdonto">
                            <div
                              role="tabpanel"
                              id="unimeOdonto"
                              class="tab-pane active show"
                              id="tabUmimedOdonto"
                              aria-expanded="true"
                              aria-labelledby="lead">
                              <div class="content-detached">
                                <!-- resultado UNIMED+ODONTO start -->
                                <section
                                  class="justify-content-center mt-4 bg-white"
                                  style="background: transparent !important">
                                  <div class="cards-resultado d-flex justify-content-center" style="box-shadow: none">
                                    <!-- Div com barra de rolagem horizontal -->
                                    <section class="justify-content-center" style="margin-top: -26px !important">
                                      <div class="carousel-container">
                                        <!-- Botão anterior -->
                                        <button
                                          *ngIf="listasDeProdutos[tipoOperadoraSelecionada].length > 2"
                                          class="carousel-control-prev"
                                          (click)="scrollPrev()"
                                          aria-label="Previous">
                                          <i class="fa fa-chevron-left fa-1x"></i>
                                        </button>

                                        <!-- Cards com scroll horizontal -->
                                        <div class="carousel-content cards-wrapper">
                                          <app-card-resultado-cotacao
                                            *ngFor="
                                              let item of listaProdutosDM && listasDeProdutos[tipoOperadoraSelecionada]
                                            "
                                            [abrangencia]="item.abrangencia"
                                            [descricao]="item.descricao"
                                            [numeroRegistro]="item.numeroRegistro"
                                            [valor]="item.valor"
                                            [id]="item.id"
                                            [idPessoa]="item.idPessoa"
                                            [idProfissao]="item.idProfissao"
                                            (comprar)="
                                              comprarOnLine(
                                                item.idLead,
                                                item.contractProductCompanyId,
                                                item.branchCompanyContractId
                                              )
                                            "></app-card-resultado-cotacao>
                                        </div>

                                        <!-- Botão próximo -->
                                        <button
                                          *ngIf="listasDeProdutos[tipoOperadoraSelecionada].length > 2"
                                          class="carousel-control-next"
                                          (click)="scrollNext()"
                                          aria-label="Next">
                                          <i class="fa fa-chevron-right fa-1x"></i>
                                        </button>
                                      </div>
                                    </section>
                                  </div>
                                </section>
                                <!-- resultado end -->
                              </div>
                            </div>
                            <div class="tab-pane" id="tabUniOdonto" aria-labelledby="tabUniOdonto">
                              <section>
                                <div class="row">
                                  <div class="col-12">
                                    <div class=" ">
                                      <div class="col-lg-12 col-xl-12">
                                        <div class="card-content">
                                          <div class="card-body">
                                            <div class="content-detached">
                                              <section
                                                class="justify-content-center mt-4 bg-white"
                                                style="background: transparent !important">
                                                <div
                                                  class="container cards-resultado d-flex justify-content-center"
                                                  style="box-shadow: none">
                                                  <!-- UNIODONTO -->
                                                  <section
                                                    class="justify-content-center"
                                                    style="margin-top: -26px !important">
                                                    <div class="carousel-container">
                                                      <!-- Botão anterior -->
                                                      <button
                                                        *ngIf="listasDeProdutos[tipoOperadoraSelecionada].length > 2"
                                                        class="carousel-control-prev"
                                                        (click)="scrollPrev()"
                                                        aria-label="Previous">
                                                        <i class="fa fa-chevron-left fa-1x"></i>
                                                      </button>

                                                      <!-- Cards com scroll horizontal -->
                                                      <div class="carousel-content cards-wrapper">
                                                        <app-card-resultado-cotacao
                                                          *ngFor="
                                                            let item of listaProdutosDM &&
                                                              listasDeProdutos[tipoOperadoraSelecionada]
                                                          "
                                                          [abrangencia]="item.abrangencia"
                                                          [descricao]="item.descricao"
                                                          [numeroRegistro]="item.numeroRegistro"
                                                          [valor]="item.valor"
                                                          [id]="item.id"
                                                          [idPessoa]="item.idPessoa"
                                                          [idProfissao]="item.idProfissao"
                                                          (comprar)="
                                                            comprarOnLine(
                                                              item.idLead,
                                                              item.contractProductCompanyId,
                                                              item.branchCompanyContractId
                                                            )
                                                          "></app-card-resultado-cotacao>
                                                      </div>

                                                      <!-- Botão próximo -->
                                                      <button
                                                        *ngIf="listasDeProdutos[tipoOperadoraSelecionada].length > 2"
                                                        class="carousel-control-next"
                                                        (click)="scrollNext()"
                                                        aria-label="Next">
                                                        <i class="fa fa-chevron-right fa-1x"></i>
                                                      </button>
                                                    </div>
                                                  </section>
                                                </div>
                                              </section>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </section>
                            </div>
                            <div class="tab-pane" id="tabOdontoPrev" aria-labelledby="tabOdontoPrev">
                              <div class="row">
                                <div class="col-12">
                                  <div class="conteudo-aba">
                                    <div class="col-lg-12 col-xl-12">
                                      <div class="card-content">
                                        <div class="card-body">
                                          <section
                                            class="justify-content-center mt-4 bg-white"
                                            style="background: transparent !important">
                                            <div
                                              class="container cards-resultado d-flex justify-content-center"
                                              style="box-shadow: none">
                                              <!-- Div com barra de rolagem horizontal -->

                                              <!-- ODONTO PREV -->

                                              <section
                                                class="justify-content-center"
                                                style="margin-top: -26px !important">
                                                <div class="carousel-container">
                                                  <!-- Botão anterior -->
                                                  <button
                                                    *ngIf="listasDeProdutos[tipoOperadoraSelecionada].length > 2"
                                                    class="carousel-control-prev"
                                                    (click)="scrollPrev()"
                                                    aria-label="Previous">
                                                    <i class="fa fa-chevron-left fa-1x"></i>
                                                  </button>

                                                  <!-- Cards com scroll horizontal -->
                                                  <div class="carousel-content cards-wrapper">
                                                    <app-card-resultado-cotacao
                                                      *ngFor="
                                                        let item of listaProdutosDM &&
                                                          listasDeProdutos[tipoOperadoraSelecionada]
                                                      "
                                                      [abrangencia]="item.abrangencia"
                                                      [descricao]="item.descricao"
                                                      [numeroRegistro]="item.numeroRegistro"
                                                      [valor]="item.valor"
                                                      [id]="item.id"
                                                      [idPessoa]="item.idPessoa"
                                                      [idProfissao]="item.idProfissao"
                                                      (comprar)="
                                                        comprarOnLine(
                                                          item.idLead,
                                                          item.contractProductCompanyId,
                                                          item.branchCompanyContractId
                                                        )
                                                      "></app-card-resultado-cotacao>
                                                  </div>

                                                  <!-- Botão próximo -->
                                                  <button
                                                    *ngIf="listasDeProdutos[tipoOperadoraSelecionada].length > 2"
                                                    class="carousel-control-next"
                                                    (click)="scrollNext()"
                                                    aria-label="Next">
                                                    <i class="fa fa-chevron-right fa-1x"></i>
                                                  </button>
                                                </div>
                                              </section>
                                            </div>
                                          </section>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- fale com o especialista start -->
              <div class="">
                <div class="col-12 col-sm-12">
                  <div class="form-group row justify-content-center">
                    <div class="">
                      <a
                        href="https://api.whatsapp.com/send?phone=551136602000&amp;text=Olá Géia, estou precisando contratar um Plano de Saúde bom e barato!"
                        target="_blank">
                        <button
                          type="button"
                          class="btn btn-float btn-success round box-shadow-4 justify-content-center"
                          style="margin-top: 40px !important">
                          <span>FALE COM UM ESPECIALISTA</span>
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- fale com o especialista start -->
            </div>
          </div>
        </ng-container>
      </mat-step>
      <!-- RESULTADO END -->
    </form>
  </mat-horizontal-stepper>
</div>

<!--   modal Cobertura-->
<div
  class="modal fade"
  id="modal-cobertura"
  tabindex="-1"
  role="dialog"
  aria-labelledby="basicModal"
  aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="heOdonto && this.tipoOperadoraSelecionada == 5">
        <div>
          <h3 class="subt-title-left span-20px mt-3">Extra Rol</h3>
          <p class="mt-2">Clareamento de dente desvitalizado</p>
          <p class="mt-2">Consulta para Técnica de Clareamento Dentário Caseiro</p>
          <p class="mt-2">Coroa total acrílica prensada</p>
          <p class="mt-2">Documentação Periodontal</p>
          <p class="mt-2">Tracionamento cirúrgico com finalidade ortodôntica</p>
        </div>
        <div>
          <h3 class="subt-title-left span-20px mt-3">Rol</h3>
          <p class="mt-2">Cirurgias</p>
          <p class="mt-2">Diagnóstico</p>
          <p class="mt-2">Extração</p>
          <p class="mt-2">Limpeza</p>
          <p class="mt-2">Odontopediatria</p>
          <p class="mt-2">Radiologia</p>
          <p class="mt-2">Restauração</p>
          <p class="mt-2">Tratamento de canal</p>
          <p class="mt-2">Tratamento de gengiva</p>
          <p class="mt-2">Urgência</p>
        </div>
      </div>
      <div *ngIf="heOdonto && this.tipoOperadoraSelecionada == 6" class="modal-body">
        <h3 class="subt-title-left span-20px mt-3">195 PROCEDIMENTOS INCLUSOS NO ROL ANS</h3>
        <p class="mt-2">COBERTURAS COMPLEMENTARES TOTALIZANDO 214 PROCEDIMENTO COBERTOS</p>
      </div>
      <div class="modal-body" *ngIf="!heOdonto">
        <div>
          <h3 class="subt-title-left span-20px mt-3">REMISSÃO</h3>
          <p class="mt-2">02 anos sem custo para os dependentes legais em caso de falecimento do titular.</p>
        </div>
        <div>
          <h3 class="subt-title-left span-20px mt-3">TRANSPORTE AEROMÉDICO INTER-HOSPITALAR(UNIAIR)</h3>
          <p class="mt-2">
            Garante remoção aermédica inter-hospitalar em caráter emergencial,sob prescrição médica solicitada por
            médico cooperado e autorizado previamente pela Unimed. A central de Atendimento da UNIAIR funciona de forma
            ininterrupta, 24 horas por dia, 7 dias por semana.
          </p>
        </div>
        <div>
          <h3 class="subt-title-left span-20px mt-3">AUXÍLIO FUNERAL</h3>
          <p class="mt-2">
            Em caso de falecimento do titular, o dependente receberá reembolso de até R$ 2.500,00(dois mil e quinhentos
            reais).
          </p>
          <span class="mt-3">*conforme condiçoes contratuais.</span>
        </div>
      </div>
    </div>
  </div>
</div>
<!--   modal Elegiveis-->
<div
  class="modal fade"
  id="modal-elegiveis"
  tabindex="-1"
  role="dialog"
  aria-labelledby="basicModal"
  aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <h3 class="subt-title-left span-20px mt-3">PLANO PARA ASSOCIADOS A</h3>
          </div>
          <div class="col-md-6">
            <h3 class="subt-title-left span-20px mt-3">ELEGÍVEIS</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 order-lg-last mt-3">
            <div class="tile-gallery-three">
              <div class="image-one">
                <!-- <img src="../../../../assets/app-assets/images/Sindicatos/Abraweb.png"
                            alt="Image"> -->
                <img [src]="logotipoUrl" alt="logo entidade" />
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-md-5 order-lg-last">
            <p class="mt-1">Cônjuge.</p>
            <p class="">União Estãvel.</p>
            <p class="">Filhos e enteados de qualquer idade.</p>
            <p class="">Menor sob guarda ou tutela.</p>
            <p class="">Filhos inválidos.</p>
            <p class="">Netos até completarem 30 anos*</p>
            <p *ngIf="this.tipoOperadoraSelecionada == 5" class="">Tutelados solteiros de qualquer idade</p>
            <p *ngIf="this.tipoOperadoraSelecionada == 5" class="">Sobrinhos</p>
            <p *ngIf="this.tipoOperadoraSelecionada == 5" class="">Netos</p>
            <p *ngIf="this.tipoOperadoraSelecionada == 5" class="">Sogro e Sogra</p>
            <p *ngIf="this.tipoOperadoraSelecionada == 5" class="">Pai e Mãe</p>
            <p *ngIf="this.tipoOperadoraSelecionada == 5" class="">Enteados solteiros de qualquer idade</p>
            <p *ngIf="this.tipoOperadoraSelecionada == 5" class="">Filhos solteiros de qualquer idade</p>
            <p *ngIf="this.tipoOperadoraSelecionada == 5" class="">Sobrinhos até completarem 30 anos*</p>
            <p *ngIf="this.tipoOperadoraSelecionada == 5">Irmãos até completarem 30 anos*</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--   modal pronto atendimento-->
<div
  class="modal fade"
  id="modal-pronto-atendimento"
  tabindex="-1"
  role="dialog"
  aria-labelledby="basicModal"
  aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="heOdonto && this.tipoOperadoraSelecionada == 5">
        <div *ngIf="heOdonto && this.tipoOperadoraSelecionada == 5">
          <h3 class="subt-title-left span-20px mt-3">Odontoprev.</h3>
          <p class="mt-2">
            Com mais de 100 mil empresas clientes e mais de 7 milhões de beneficiários, o Grupo OdontoPrev é líder do
            segmento de Assistência Odontológica há mais de 20 anos e possui atualmente a maior operação da América
            Latina. Está presente em mais de 2600 municípios de todas as regiões do país e conta com mais de 29 mil
            credenciados.
          </p>
        </div>
      </div>
      <div class="modal-body" *ngIf="heOdonto">
        <div *ngIf="heOdonto && this.tipoOperadoraSelecionada == 4">
          <h3 class="subt-title-left span-20px mt-3">Uniodonto.</h3>
          <p class="mt-2">
            O Maior Sistema de Cooperativas Odontológicas do Mundo A maior rede de atendimento em planos odontológicos
            do mundo, que consolidou o atendimento a 3 milhões usuários no Brasil, prestado por cerca de 20 mil
            cirurgiões dentistas cooperados, organizados em 130 singulares.
          </p>
        </div>
        <div *ngIf="heOdonto && this.tipoOperadoraSelecionada == 6">
          <h3 class="subt-title-left span-20px mt-3">Unimed Odonto.</h3>
          <p class="mt-2">
            A Unimed Odonto é a operadora odontológica do Sistema Unimed sob gestão da Seguros Unimed. Com atuação desde
            2009 e sede em São Paulo, possui uma carteira com mais de 450 mil beneficiários, mantendo representatividade
            em todo território nacional.
          </p>
        </div>
        <div *ngIf="heOdonto && this.tipoOperadoraSelecionada == 6">
          <h3 class="subt-title-left span-20px mt-3">Telemedicina do Einstein</h3>
          <p class="mt-2">Um serviço de orientação médica: onde você estiver, na hora que precisar.</p>

          <ul>
            Atendimento online direto do seu celular ou computador
            <li>24h por dia7 dias por semana</li>
            <li>Qualidade Einstein</li>
          </ul>
        </div>
      </div>
      <div class="modal-body" *ngIf="!heOdonto">
        <div class="row">
          <div class="col-md-12">
            <h3 class="subt-title-left span-20px mt-3" style="font-size: 3em; font-weight: 200">
              Pronto Atendimento
              <span class="title-left" style="font-size: 1em">Virtual</span>
            </h3>
          </div>
          <div class="col-lg-8 col-md-8">
            <p class="mt-2">
              O Einstein Conecta é uma plataforma que disponibiliza profissionais do Einstein, seguindo diretrizes de
              atendimento similares ao de um Pronto Atendimento. Assim, sempre que sentir algum mal-estar de baixa
              urgência, busque por orientação profissional.
            </p>
            <p class="mt-2">
              Antes de se deslocar a um pronto atendimento e se expor a doenças de contágio rápido, você pode receber a
              orientação médica adequada para saber o melhor a ser feito.
            </p>
            <p class="mt-2">
              É importante lembrar, que o acesso ao Einstein Conecta não dá direito a outros serviços do Hospital
              Israelita Albert Einstein.
            </p>
            <span class="subt-title-left span-20px mt-3">
              Visite:
              <a href="https://telemedicina.einstein.br/" target="_blank">conecta.einstein.br</a>
            </span>
            <div class="col-md-6">
              <img src="../../../../assets/app-assets/images/ilustracao/icon-lojas.png" alt="Image" />
            </div>
          </div>
          <div class="col-lg-4 col-md-4">
            <div class="tile-gallery-three">
              <div style="height: 79% !important; width: 103% !important">
                <img src="../../../../assets/app-assets/images/ilustracao/modal-atendiemento.png" alt="Image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--   modal pronto DUVIDAS-->
<div class="modal fade" id="modal-duvidas" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <h3 class="subt-title-left span-20px mt-1" style="font-size: 2em; font-weight: 200">
              Dúvidas
              <span class="title-left" style="font-size: 1em">frequentes</span>
            </h3>
          </div>
          <div class="row match-height mt-2">
            <div class="col-lg-12 col-xl-12">
              <div id="accordionWrapa1" role="tablist" aria-multiselectable="true">
                <div class="col-lg-12 col-xl-12">
                  <div id="heading1" class="card-header collapse-format border-info mt-1 mb-1" role="tab">
                    <a
                      data-toggle="collapse"
                      data-parent="#accordionWrapa1"
                      href="#accordion1"
                      aria-expanded="false"
                      aria-controls="accordion1"
                      class="card-title lead collapsed">
                      Quais as vigências do plano de saúde Unimed Fesp?
                    </a>
                  </div>
                  <div id="accordion1" role="tabpanel" aria-labelledby="heading1" class="collapse">
                    <div class="card-content" style>
                      <div class="card-body">
                        As vigências para contratação dos planos de saúde coletivo, são 1 e 15 de cada mês.
                      </div>
                    </div>
                  </div>
                  <div id="heading2" class="card-header collapse-format border-info mt-1 mb-1">
                    <a
                      data-toggle="collapse"
                      data-parent="#accordionWrapa1"
                      href="#accordion2"
                      aria-expanded="false"
                      aria-controls="accordion2"
                      class="card-title lead collapsed">
                      Quais as formas de pagamento do plano?
                    </a>
                  </div>
                  <div
                    id="accordion2"
                    role="tabpanel"
                    aria-labelledby="heading2"
                    class="collapse"
                    aria-expanded="false">
                    <div class="card-content">
                      <div class="card-body">
                        O pagamento de sua mensalidade ocorrerá através do débito automático com os bancos conveniados.
                      </div>
                    </div>
                  </div>
                  <div id="heading3" class="card-header collapse-format border-info mt-1 mb-1">
                    <a
                      data-toggle="collapse"
                      data-parent="#accordionWrapa1"
                      href="#accordion3"
                      aria-expanded="false"
                      aria-controls="accordion3"
                      class="card-title lead collapsed">
                      Qual o vencimento da mensalidade?
                    </a>
                  </div>
                  <div
                    id="accordion3"
                    role="tabpanel"
                    aria-labelledby="heading3"
                    class="collapse"
                    aria-expanded="false">
                    <div class="card-content">
                      <div class="card-body">O pagamento será todo 5º dia útil após início da vigência.</div>
                    </div>
                  </div>
                  <div id="heading4" class="card-header collapse-format border-info mt-1 mb-1">
                    <a
                      data-toggle="collapse"
                      data-parent="#accordionWrapa1"
                      href="#accordion4"
                      aria-expanded="false"
                      aria-controls="accordion4"
                      class="card-title lead collapsed">
                      O que é o valor pago no ato da contratação?
                    </a>
                  </div>
                  <div
                    id="accordion4"
                    role="tabpanel"
                    aria-labelledby="heading4"
                    class="collapse"
                    aria-expanded="false"
                    style="height: 0px">
                    <div class="card-content">
                      <div class="card-body">
                        Esse pagamento se refere a taxa de adesão e não poderá ser confundia com a primeira mensalidade.
                      </div>
                    </div>
                  </div>
                  <div id="heading5" class="card-header collapse-format border-info mt-1 mb-1">
                    <a
                      data-toggle="collapse"
                      data-parent="#accordionWrapa1"
                      href="#accordion5"
                      aria-expanded="false"
                      aria-controls="accordion5"
                      class="card-title lead collapsed">
                      Quais são as carências contratuais?
                    </a>
                  </div>
                  <div
                    id="accordion5"
                    role="tabpanel"
                    aria-labelledby="heading5"
                    class="collapse"
                    aria-expanded="false"
                    style="height: 0px">
                    <div class="card-content">
                      <div class="card-body">
                        <p>
                          <b>24 Horas</b>
                          Urgências e Emergências – Acidentes Pessoais (conforme resolução CONSU nº13/88)
                        </p>
                        <p>
                          <b>30 Dias</b>
                          Consultas e Exames Complementares
                        </p>
                        <p>
                          <b>90 Dias</b>
                          Fisioterapias, Exames Especiais e Procedimentos ambulatoriais.
                        </p>
                        <p>
                          <b>180 Dias</b>
                          Internações Clínicas e Cirúrgicas, Quimioterapia, Radioterapia, Diálise e Hemodiálise
                        </p>
                        <p>
                          <b>300 Dias</b>
                          Parto a Termo
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #modalConfimar let-modal>
  <div class="modal-header bg bg-info">
    <h5 class="modal-title white" id="exampleModalLongTitle">Aviso.</h5>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12 text-center mt-2 mb-2">
        <h2>Você sera redirecionado para a tela de autenticação.</h2>
        <br />
        <p>Caso queira acessar mas tarde, foi enviado no email cadastrado o link para acesso.</p>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-success round box-shadow-4 mr-2" (click)="confirmar()">
        <i class="ft-thumbs-up"></i>
        Confirmar
      </button>
      <button type="button" class="btn btn-warning round box-shadow-4" (click)="decline()">
        <i class="ft-thumbs-down"></i>
        Cancelar
      </button>
    </div>
  </div>
</ng-template>

<ngx-spinner
  type="ball-newton-cradle"
  [fullScreen]="true"
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"></ngx-spinner>
